// extracted by mini-css-extract-plugin
export var collapsedSummary = "_lx-0";